import React from 'react'
import HeroSection from '../Component/HeroSection'  // من غير الأقواس المعقوفة
// import Navbarsection from '../Component/Navbarsection'
import { AboutUs } from '../Component/AboutUs'
import { OurService } from '../Component/OurService'
import { OurBlogs } from '../Component/OurBlogs'
import { ClientOpinion } from '../Component/ClientOpinion'
import { Contactus } from '../Component/Contactus'

export const HomePage = () => {
  return (
    <div>
        {/* <Navbarsection/> */}
        <HeroSection/>
        <AboutUs/>
        <OurService/>
        <OurBlogs/>
        <ClientOpinion/>
        <Contactus/>
    </div>
  )
}